import * as React from 'react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

import {Helmet} from "react-helmet";
//import { Helmet, HelmetProvider } from "react-helmet-async";
import * as constants from './constants';
import PreloadFonts from "./PreloadFonts";

const rootElement = document.getElementById('root')!;
const root = createRoot(rootElement);

root.render(
  <StrictMode>
    {/* <HelmetProvider> */}
      <Helmet>
          <title>{constants.APP_TITLE}</title>
          
          <meta name="description" content={constants.APP_DESCRIPTION} />
          <meta name="keywords" content={constants.APP_KEYWORDS} /> 

          <meta property="og:title" content={constants.APP_TITLE} />
          <meta property="og:description" content={constants.APP_DESCRIPTION} />
          <meta property="og:image" content={constants.APP_CDN_URL+constants.APP_IMAGE} />

      </Helmet>   
      <PreloadFonts /> 
      <App></App>
    {/* </HelmetProvider> */}
  </StrictMode>
);